import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["appState", "areBothGoogleAuth", "backupCodesEnabled", "callForCode", "hasSecondaryMethod", "lastFour", "onLostDevice", "retryCode", "switchAppState", "switchVerificationMethod", "twoFactorAuthMethod", "onRestartTimer"];
import { useCallback } from 'react';
import { HR } from 'foundations-components/transitional/components/HR';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { View } from 'foundations-components/transitional/components/View';
import TwoFactorAuthMethods from 'LoginUI/constants/TwoFactorAuthMethods';
import { Header } from 'LoginUI/components/Header';
import { Footer } from 'LoginUI/components/Footer';
import { NeedHelp } from './NeedHelp';
import { TwoFactorAuthenticatorForm } from './TwoFactorAuthenticatorForm';
import { TwoFactorHubspotForm } from './TwoFactorHubspotForm';
import { TwoFactorSmsForm } from './TwoFactorSmsForm';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { H3 } from 'foundations-components/transitional/components/H3';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CodeEntryForm } from './CodeEntryForm';
import TwoFactorAuthAppStates from 'LoginUI/constants/TwoFactorAuthAppStates';
import { TwoFactorAlerts } from './TwoFactorAlerts';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const TwoFactorAuthVerifyV4 = _ref => {
  let {
      appState,
      areBothGoogleAuth,
      backupCodesEnabled,
      callForCode,
      hasSecondaryMethod,
      lastFour,
      onLostDevice,
      retryCode,
      switchAppState,
      switchVerificationMethod,
      twoFactorAuthMethod,
      onRestartTimer
    } = _ref,
    codeEntryFormProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const toggleBackupCodesModal = useCallback(() => {
    switchAppState();
  }, [switchAppState]);
  if (!twoFactorAuthMethod) {
    return null;
  }
  const backupModalOpen = appState === TwoFactorAuthAppStates.BACKUP;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Header, {}), /*#__PURE__*/_jsx(TFlex, {
      align: "center",
      justify: "center",
      children: /*#__PURE__*/_jsxs(View, {
        inlineSize: "480px",
        textAlign: "center",
        children: [/*#__PURE__*/_jsx(TwoFactorAlerts, {
          onRestartTimer: onRestartTimer
        }), twoFactorAuthMethod === TwoFactorAuthMethods.SMS && /*#__PURE__*/_jsx(TwoFactorSmsForm, Object.assign({
          callForCode: callForCode,
          lastFour: lastFour,
          retryCode: retryCode,
          isModalOpen: backupModalOpen
        }, codeEntryFormProps)), twoFactorAuthMethod === TwoFactorAuthMethods.GOOGLE_AUTHENTICATOR && /*#__PURE__*/_jsx(TwoFactorAuthenticatorForm, Object.assign({
          isModalOpen: backupModalOpen
        }, codeEntryFormProps)), twoFactorAuthMethod === TwoFactorAuthMethods.HUBSPOT_AUTHENTICATOR && /*#__PURE__*/_jsx(TwoFactorHubspotForm, Object.assign({}, codeEntryFormProps, {
          type: "modal"
        })), /*#__PURE__*/_jsx(HR, {}), /*#__PURE__*/_jsx(NeedHelp, {
          areBothGoogleAuth: areBothGoogleAuth,
          backupCodesEnabled: backupCodesEnabled,
          hasSecondaryMethod: hasSecondaryMethod,
          onLostDevice: onLostDevice,
          switchVerificationMethod: switchVerificationMethod,
          toggleBackupCodesModal: toggleBackupCodesModal
        })]
      })
    }), /*#__PURE__*/_jsx(Footer, {}), backupModalOpen && /*#__PURE__*/_jsx(Modal, {
      children: /*#__PURE__*/_jsxs(DialogBody, {
        children: [/*#__PURE__*/_jsx(H3, {
          "aria-level": 1,
          marginBlockEnd: "600",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "twoFactorV4.backupCodes.title"
          })
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "twoFactorV4.backupCodes.description"
        }), /*#__PURE__*/_jsx(CodeEntryForm, Object.assign({}, codeEntryFormProps, {
          closeModal: toggleBackupCodesModal,
          type: "modal"
        }))]
      })
    })]
  });
};